<template>
    <div class="row order-info">
        <div class="row mt-2 mb-4" v-if="showLocationsError">
            <div class="alert alert-danger" role="alert">
                Please assign a location for this user before activating.
            </div>
        </div>
        <div class="col-md-12">
            <span
                class="text-underline cursor-pointer text-muted"
                style="position: absolute; top: -25px"
                @click="$router.back()"
                ><i class="fa fa-arrow-left" aria-hidden="true"></i>
                Go back
            </span>
            <div class="d-flex align-items-center">
                <h3>{{ userInfo?.name }}</h3>
                <span
                    class="add-button btn btn-action ml-3"
                    @click="changePassword(userInfo?.id)"
                >
                    Change password
                </span>
                <div class="px-3">
                    <div class="d-flex align-items-center">
                        <div class="form-check form-switch pr-3">
                            <input
                                class="form-check-input cursor-pointer"
                                type="checkbox"
                                id="formSwitchChecked"
                                :checked="userInfo.online_order == 1"
                                @change="updateOnlineOrder(userInfo.id)"
                            />
                            <label
                                class="form-check-label cursor-pointer"
                                for="formSwitchChecked"
                                >{{
                                    userInfo.online_order == 1
                                        ? "Online Order Enabled"
                                        : "Online Order Disabled"
                                }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="px-3">
                    <div class="d-flex align-items-center">
                        <div class="form-check form-switch pr-3">
                            <input
                                class="form-check-input cursor-pointer"
                                type="checkbox"
                                id="formSwitchChecked2"
                                :checked="userInfo.is_demo == 1"
                                @change="updateDemoAccount(userInfo.id)"
                            />
                            <label
                                class="form-check-label cursor-pointer"
                                for="formSwitchChecked2"
                                >{{
                                    userInfo.is_demo == 1
                                        ? "Demo Account Enabled"
                                        : "Demo Account Disabled"
                                }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="px-3">
                  <div class="d-flex align-items-center">
                    <TwoFactorToggle
                      :user-id="userInfo.id"
                      :show-label="true"
                      :initial-state="userInfo.two_factor_auth"
                      @update:modelValue="() => handle2FAChange()"
                    />
                  </div>
                </div>
            </div>
            <span class="text-muted"
                >Last Login: {{ userInfo?.last_login_data }}</span
            >
            <div class="row mt-4">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Role:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ userInfo?.role?.display_name }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Email:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span>{{ userInfo?.email }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-sm-3 col-md-2">
                            <label>Address:</label>
                        </div>
                        <div class="col-sm-9 col-md-10">
                            <span
                                >{{ userInfo?.address }}, {{ userInfo?.city }},
                                {{ userInfo?.state }},
                                {{ userInfo?.zip_code }}</span
                            >
                            <span
                                class="add-button btn btn-action ml-3"
                                @click="openModalAddress(userInfo, 'edit')"
                                >Edit Address</span
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-sm-12 col-md-auto pt-4">
                    <span
                        v-if="userInfo?.status == 1"
                        class="add-button btn btn-action"
                        @click="confirmModal(userInfo?.id, 'disable')"
                        >Disable Account</span
                    >
                    <span
                        v-else
                        class="add-button btn btn-action"
                        @click="enableAccount"
                        >Enable Account</span
                    >
                </div>
                <div class="col-sm-12 col-md-auto pt-4">
                    <span
                        class="add-button btn btn-action"
                        @click="sendAccountApprovedEmail(userInfo?.id)"
                        >Send Account Approved Email</span
                    >
                </div>
                <div v-if="userInfo?.is_flagged" class="col-sm-12 col-md-auto pt-4">
                    <span
                        class="add-button btn btn-flagged-user"
                        @click="flagDealerUser(userInfo?.id, 0)"
                        >Unflag Dealer</span
                    >
                </div>
                <div v-if="!userInfo?.is_flagged" class="col-sm-12 col-md-auto pt-4">
                    <span
                        class="add-button btn btn-action"
                        @click="flagDealerUser(userInfo?.id, 1)"
                        >Flag Dealer</span
                    >
                </div>
                <div class="col-sm-12 col-md-auto pt-4">
                  <span class="add-button btn btn-action">
                    <LockUnlockButton
                      :user="userInfo"
                      :current-user="user"
                      @success="handleLockUnlockSuccess"
                    />
                  </span>
                </div>
            </div>
            <div
                class="d-flex align-items-center justify-content-between pt-4 pb-2"
            >
                <h5>Locations</h5>
                <span
                    class="add-button btn btn-action"
                    @click="openModalLocation(null, 'add')"
                >
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                    ADD LOCATION
                </span>
            </div>
            <table class="table table-responsive table-striped mb-0">
                <thead class="thead-light">
                    <tr>
                        <th>Name</th>
                        <th>Sales Rep</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Pricelist Name</th>
                        <th>Speq Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item, idx) in locations" :key="idx">
                        <tr>
                            <!-- <td>{{ item.name }}</td> -->
                            <td class="hyperlink" @click="viewDealer(item)">
                                <b>{{ item.name }}</b>
                            </td>
                            <td>{{ item.sales_rep?.name }}</td>
                            <td>{{ item.address }}</td>
                            <td>{{ item.city }}</td>
                            <td>{{ item.state }}</td>
                            <td>{{ item.zip_code }}</td>
                            <td>{{ item.phone }}</td>
                            <td>{{ item.email }}</td>
                            <td>{{ item.pricelist?.pricelist_name }}</td>
                            <td>
                                <span
                                    v-if="item.is_speq === 1"
                                    class="badge badge-success"
                                >
                                    Enrolled
                                </span>
                                <span
                                    class="badge badge-primary"
                                    v-else-if="item.speq_invite_status == 1"
                                >
                                    Invite Sent
                                </span>
                                <span
                                    class="badge badge-warning"
                                    v-else-if="item.speq_invite_status == 2"
                                >
                                    Pending
                                </span>
                                <span
                                    class="badge badge-declined"
                                    v-else-if="item.speq_invite_status == 4"
                                >
                                    Declined
                                </span>
                                <span class="badge badge-secondary" v-else>
                                    N/A
                                </span>
                            </td>
                            <td class="text-right">
                                <div
                                    class="px-1 view-action"
                                    @click="
                                        confirmModal(
                                            userInfo.id,
                                            'delete',
                                            item.id
                                        )
                                    "
                                >
                                    <i
                                        class="fa fa-trash"
                                        aria-hidden="true"
                                    ></i>
                                    DELETE
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="col-md-12 pt-4">
            <h5>Users</h5>
            <table class="table table-responsive table-striped">
                <thead class="thead-light">
                    <tr>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Address</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Zip</th>
                        <th>Phone</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    <template
                        v-for="(item, idx) in subUsersByUserId"
                        :key="idx"
                    >
                        <tr>
                            <td>{{ item.name }}</td>
                            <td>{{ item.role.display_name }}</td>
                            <td>{{ item.address }}</td>
                            <td>{{ item.city }}</td>
                            <td>{{ item.state }}</td>
                            <td>{{ item.zip_code }}</td>
                            <td>{{ item.phone }}</td>
                            <td>{{ item.email }}</td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>

        <!-- Add location modal -->
        <b-modal
            v-model="modalShowLocation"
            :title="modalType == 'add' ? 'ADD LOCATION' : 'EDIT LOCATION'"
            hide-footer
        >
            <LocationModal
                v-if="modalShowLocation"
                :modal-data="modalData"
                :modal-type="modalType"
                @close-modal="closeModalLocation"
            />
        </b-modal>

        <!-- Update address modal -->
        <b-modal v-model="modalShowAddress" :title="'EDIT ADDRESS'" hide-footer>
            <AddressModal
                v-if="modalShowAddress"
                :modal-data="modalData"
                :modal-type="modalType"
                @update-user-info="updateUserInfo"
                @close-modal="closeModalAddress"
            />
        </b-modal>

        <!-- Update password modal -->
        <b-modal v-model="modalShowPassword" hide-footer>
            <ChangePasswordModal
                v-if="modalShowPassword"
                :modal-data="modalData"
                @close-modal="closeModalPassword"
            />
        </b-modal>

        <!-- Confirmation modal -->
        <b-modal v-model="modalShowConfirm" hide-footer>
            <Confirmation
                v-if="modalShowConfirm"
                :title="title"
                @custom-func="updateStatus"
                @close-modal="closeModalConfirm"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import LocationModal from "@/components/modals/LocationModal.vue";
import AddressModal from "@/components/modals/AddressModal.vue";
import ChangePasswordModal from "@/components/modals/ChangePasswordModal.vue";
import Confirmation from "@/components/Confirmation.vue";
import LockUnlockButton from "../../LockUnlockButton.vue";
import TwoFactorToggle from "../../settings/TwoFactorToggle.vue";

export default {
    props: ["id"],
    emits: [],
    components: {
        LocationModal,
        AddressModal,
        ChangePasswordModal,
        Confirmation,
        LockUnlockButton,
        TwoFactorToggle
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let userInfo = computed(function () {
            return store.state.userInfo;
        });
        let subUsersByUserId = computed(function () {
            return store.state.subUsersByUserId;
        });
        let locations = computed(function () {
            return store.state.locations;
        });

        // function getLocations(userId) {
        //     store.dispatch('getLocations', {user_id: userId});
        // }

        function activateUser(id) {
            store.dispatch("activateUser", id);
        }

        // function getSubUsersByUserId(userId) {
        //     store.dispatch("getSubUsersByUserId", {user_id: userId});
        // }

        function sendAccountApprovedEmail(id) {
            store.dispatch("sendAccountApprovedEmail", id);
        }

        function setLocationInfo(location) {
            store.commit("setLocationInfo", location);
        }

        function deleteLocationFromUser(request) {
            store.commit("deleteLocationFromUser", request);
        }

        function updateUserOnlineOrder(id) {
            store.dispatch("updateUserOnlineOrder", id);
        }

        function updateUserDemoAccount(id) {
            store.dispatch("updateUserDemoAccount", id);
        }

        function flagUser(request) {
            store.dispatch("flagUser", request);
        }

        onMounted(() => {});

        return {
            store,
            user,
            userInfo,
            subUsersByUserId,
            locations,
            // getLocations,
            activateUser,
            // getSubUsersByUserId,
            sendAccountApprovedEmail,
            setLocationInfo,
            deleteLocationFromUser,
            updateUserOnlineOrder,
            updateUserDemoAccount,
            flagUser
        };
    },
    data() {
        return {
            modalShowLocation: false,
            modalType: null,
            modalData: {},
            salesRep: "",
            emailSent: false,
            modalShowPassword: false,
            userid: null,
            modalShowConfirm: false,
            title: "",
            type: "",
            locationid: null,
            modalShowAddress: false,
            showLocationsError: false,
        };
    },
    mounted() {
        this.store.dispatch("getUserById", this.id);
        // this.getLocations(this.userInfo.id);
        // this.getSubUsersByUserId(this.userInfo.id);
    },
    methods: {
        openModalLocation(data, val) {
            let newData = {
                user_id: this.userInfo.id,
            };
            // this.modalData = data;
            this.modalData = newData;
            this.modalType = val;
            this.modalShowLocation = !this.modalShowLocation;
        },
        closeModalLocation() {
            this.modalShowLocation = !this.modalShowLocation;
        },
        confirmModal(userid, type, locationid = null) {
            if (type == "enable") {
                this.title = "Are you sure you want to enable this account?";
            } else if (type == "disable") {
                this.title = "Are you sure you want to disable this account?";
            } else if (type == "delete") {
                this.title = "Are you sure you want to delete this location?";
            }

            this.type = type;
            this.userid = userid;
            this.locationid = locationid;
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        updateStatus() {
            if (this.type == "delete") {
                this.store
                    .dispatch("deleteLocationFromUser", {
                        user_id: this.userid,
                        location_id: this.locationid,
                    })
                    .then((resp) => {
                        this.store.dispatch("getUserById", this.id);
                        window.emitter.emit("alertSuccess", {
                            message: "Location is removed successfully!",
                        });
                    });
            } else {
                this.userInfo.status = !this.userInfo.status;
                this.activateUser(this.userid);
                window.emitter.emit("alertSuccess", {
                    message:
                        this.type == "enable"
                            ? "Account is enabled successfully!"
                            : "Account is disabled successfully!",
                });
            }
        },
        closeModalConfirm() {
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        sendAccountApprovedEmail(userid) {
            this.sendAccountApprovedEmail(userid);

            window.emitter.emit("alertSuccess", {
                message: "Email sent successfully!",
            });
        },
        closeModalPassword() {
            this.modalShowPassword = !this.modalShowPassword;
        },
        changePassword(id) {
            this.modalData.id = id;
            this.modalShowPassword = !this.modalShowPassword;
        },
        viewDealer(location) {
            this.setLocationInfo(location);
            this.$router.push({
                name: "speqDealerInfo",
                params: { id: location.id },
            });
        },
        updateOnlineOrder(userid) {
            this.userInfo.online_order = !this.userInfo.online_order;
            this.updateUserOnlineOrder(userid);
            window.emitter.emit("alertSuccess", {
                message: this.userInfo.online_order
                    ? "Online Order is enabled successfully!"
                    : "Online Order is disabled successfully!",
            });
        },
        updateDemoAccount(userid) {
            this.userInfo.is_demo = !this.userInfo.is_demo;
            this.updateUserDemoAccount(userid);
            window.emitter.emit("alertSuccess", {
                message: this.userInfo.is_demo
                    ? "Demo Account is enabled successfully!"
                    : "Demo Account is disabled successfully!",
            });
        },
        openModalAddress(data, val) {
            this.modalData = data;
            this.modalType = val;
            this.modalShowAddress = !this.modalShowAddress;
        },
        closeModalAddress() {
            this.modalShowAddress = !this.modalShowAddress;
        },
        updateUserInfo() {
            this.store.dispatch("getUserById", this.id);
        },
        enableAccount() {
            if (this.locations.length == 0) {
                this.flashLocationsError();
            } else {
                this.confirmModal(this.userInfo?.id, "enable");
            }
        },
        flashLocationsError() {
            this.showLocationsError = true;
            setTimeout(() => {
                this.showLocationsError = false;
            }, 5000);
        },
        flagDealerUser(userid, flag) {
            var request = {
                userid: userid,
                flag: flag
            }
            this.flagUser(request);

            window.emitter.emit("alertSuccess", {
                message: flag ? "User has been flagged successfully!" : "User has been unflagged successfully!",
            });
        },

        handleLockUnlockSuccess(user) {
          this.updateUserInfo()
        },

        async handle2FAChange() {
          try {
            await this.store.dispatch('toggle2FA', this.userInfo.id);
          } catch (error) {
            this.handleError(error);
          }
        },
    },
};
</script>
